import { QUERY_DELETE_DELETEENTRYCHANNEL, QUERY_GET_ENTRYCHANNELS, QUERY_GET_ENTRYCHANNELSPAG, QUERY_POST_CREATEENTRYCHANNEL, QUERY_PUT_EDITENTRYCHANNEL} from '../../fetch/constantQueries'
import { baseThunk, getUrl } from '../../fetch/basicThunk';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDelete, fetchPut } from '../../fetch/fetchConfig';

export const getEntryChannels = baseThunk(`entryChannels/getEntryChannels`, QUERY_GET_ENTRYCHANNELS, "GET");
export const getEntryChannelsPag = baseThunk(`entryChannels/getEntryChannelsPag`, QUERY_GET_ENTRYCHANNELSPAG, "GET");

export const createEntryChannel = baseThunk("entryChannel/create", QUERY_POST_CREATEENTRYCHANNEL, "POST");
export const deleteEntryChannel = baseThunk("entryChannel/delete", QUERY_DELETE_DELETEENTRYCHANNEL, "DELETE");
export const editEntryChannel = baseThunk("entryChannel/dupdate", QUERY_PUT_EDITENTRYCHANNEL, "PUT");

// export const deleteEntryChannel = createAsyncThunk(
//     'entryChannel/delete/',
//     async (entryChannelId, thunkApi) => {
//           const response = await fetch( getUrl() + QUERY_DELETE_DELETEENTRYCHANNEL + `${entryChannelId}`, fetchDelete());
//           if (!response.ok){
//             throw response.status};
//           const data = response.json()
//           return data
//     }
//   );

// export const editEntryChannel = createAsyncThunk(
//     'entryChannel/update/',
//     async (editEntryChannelParams, thunkApi) => {
//           const { entryChannelId, body } = editEntryChannelParams;
//           const response = await fetch( getUrl() + QUERY_PUT_EDITENTRYCHANNEL + `${entryChannelId}`, fetchPut(body));
//           if (!response.ok){
//             throw response.status};
//           const data = response.json()
//           return data
//     }
//   )